import AxiosInstance from "../Utils/axios/axiosConfig";
import axios from "axios";
// import { IMAGE_BASE_URL } from "../Constants/serverAddress"
import { getUserEmailId } from "./localStorageServices";

const fileUploadAxios = axios.create({
    // baseURL: IMAGE_BASE_URL
})

fileUploadAxios.interceptors.response.use(
    (res) => {
        // res.header('Access-Control-Allow-Credentials', "*");
        return res;
    })

    const poUploadAxios = axios.create({
      // baseURL:IMAGE_BASE_URL
  })
  
  poUploadAxios.interceptors.response.use(
      (res) => {
          res.header('Access-Control-Allow-Credentials', "*");
          return res;
      },)

      export const uploadUserGuideImages = async (url,body) => {
        const response = await fileUploadAxios.put(url, body);
        if (!response.data.error) {
          return response.data;
        } else {
          return Promise.reject(response);
        }
      };

export const uploadFile = async (file) => {
    const userEmailId = getUserEmailId();
    return await fileUploadAxios.put(`${userEmailId}/${file.name}`, file)
}
export const newUploadOrders = async (url,body) => {
    const response = await fileUploadAxios.put(url, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };
  export const newDeleteOrders = async (url,body) => {
    const response = await fileUploadAxios.delete(url, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };
// export const newUploadOrders = async (url, body) => {
//   try {
//     const response = await AxiosInstance.put(url, body, {
//       baseURL: "", // don’t prepend API_SERVER_ADDRESS
//       headers: {}, // 🔑 no extra headers
//     });

//     if (response.status === 200 || response.status === 204) {
//       return { success: true, url };
//     } else {
//       return Promise.reject({
//         success: false,
//         status: response.status,
//       });
//     }
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };


export const uploadPODocuments = async (po, file) => {
  return await poUploadAxios.put(`${po}/${file.name}`, file);
}

export const deletePODocuments = async (po, file) => {
  return await poUploadAxios.delete(`${po}/${file.name}`);
}

export const uploadOrders = async (body) => {
    const response = await AxiosInstance.post("/orders/imports/general/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const uploadProducts = async (body,source=undefined) => {
    const response = await AxiosInstance.post("products/imports/", body, {cancelToken: source.token});
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const saveUploadedProducts = async (body) => {
    const response = await AxiosInstance.post("products/imports/upload/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const uploadCustomers = async (body,source=undefined) => {
    const response = await AxiosInstance.post("customers/imports/", body,{cancelToken: source.token});
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const saveUploadedCustomers = async (body) => {
    const response = await AxiosInstance.post("customers/imports/upload/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };